var render, staticRenderFns
import script from "./main-router.vue?vue&type=script&lang=js"
export * from "./main-router.vue?vue&type=script&lang=js"
import style0 from "./main-router.vue?vue&type=style&index=0&id=670453b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670453b0",
  null
  
)

export default component.exports